import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Input, Text } from "@fragments";
import { WidgetsRounded } from "@mui/icons-material";

// Labels resolve at render so they follow the active language; `value` is the
// API keyword and must never be translated.
const getTypeOptions = (t) => [
    {
        value: "CHALLENGE",
        label: t("manageGroup.type.challenge.label"),
        description: t("manageGroup.type.challenge.description"),
    },
    {
        value: "LIFETIME",
        label: t("manageGroup.type.lifetime.label"),
        description: t("manageGroup.type.lifetime.description"),
    },
];

export default function TypeSelector({ value, onChange }) {
    const { t } = useTranslation("groupModals");

    const typeOptions = useMemo(() => getTypeOptions(t), [t]);

    return (
        <>
            <Text.h3
                value={t("manageGroup.type.title")}
                className="mt-5 mb-1"
                grow
                left={<WidgetsRounded />}
            />
            <Input.Choices
                value={value}
                onInput={onChange}
                options={typeOptions}
            />
        </>
    );
}
